// AB#1860 — interpolate `{field}` tokens in a static-text string against a record.
// Literal when no tokens; unknown / null / undefined tokens render as empty. Pure + DOM-free.
export function interpolateTokens(raw: string, record: Record<string, unknown>): string {
    if (!raw.includes('{')) { return raw }
    return raw.replace(/\{(\w+)\}/g, (_m, key: string) => {
        const v = record[key]
        return v === null || v === undefined ? '' : String(v)
    })
}
